import React from 'react';
import { ItemType, TrackableItem } from '../../graphql/generatedTypes';
import { Button } from 'reactstrap';
import { FaEdit } from 'react-icons/fa';
import TrackableItemDisplay from '../../components/TrackableItem/TrackableItemDisplay';
import { centsToPrice } from '@/utils/formatter';
import { isNullOrWhitespace } from '@/utils/stringHelper';
import { BillingFrequency } from '../../graphql/generatedTypes';
import i18n from '@/utils/i18n';

function billingFrequencyToTranslationKey(
  frequency: string | null | undefined,
): string {
  if (!frequency) return '';
  // Convert enum values (MONTHLY, ONE_TIME, YEARLY) to camelCase (Monthly, OneTime, Yearly)
  if (frequency === BillingFrequency.Monthly) return 'Monthly';
  if (frequency === BillingFrequency.OneTime) return 'OneTime';
  if (frequency === BillingFrequency.Yearly) return 'Yearly';
  return frequency;
}

interface ItemTypeTableRowProps {
  itemType: ItemType;
  onEdit: () => void;
  isEditable?: boolean;
  currency?: string;
}

export function ItemTypeTableRow({
  itemType,
  onEdit,
  isEditable = true,
  currency = 'EUR',
}: ItemTypeTableRowProps) {
  return (
    <tr key={`item-type-${itemType.id}`}>
      <td className="align-middle">{itemType.id}</td>
      <td>
        {itemType.image_url && (
          <TrackableItemDisplay
            trackableItem={{ item_type: itemType } as TrackableItem}
            showLink={false}
            showTrackableItemId={false}
          />
        )}
      </td>
      <td className="align-middle">{itemType.name}</td>
      <td className="align-middle">
        <span className="font-monospace">{itemType.sku || '-'}</span>
      </td>
      <td className="align-middle">
        <div className="input-group">
          <input
            style={{ height: 'inherit' }}
            type="color"
            className="form-control"
            value={`#${itemType.color_hex_code || 'FFFFFF'}`}
            disabled
          />
          <span className="form-control">
            {itemType.color_hex_code || 'FFFFFF'}
          </span>
        </div>
      </td>
      <td>{i18n.t(`ItemType:category${itemType.category}`)}</td>
      <td className="align-middle">
        {itemType.billing_category
          ? i18n.t(`ItemType:billingCategory${itemType.billing_category}`)
          : '-'}
      </td>
      <td className="align-middle">
        {itemType.price != null ? centsToPrice(itemType.price, currency) : '-'}
      </td>
      <td className="align-middle">
        {!isNullOrWhitespace(itemType.billing_frequency)
          ? i18n.t(
              `ItemType:billingFrequency${billingFrequencyToTranslationKey(itemType.billing_frequency)}`,
            )
          : '-'}
      </td>
      <td className="align-middle">
        {itemType.archived ? i18n.t('Common:yes') : i18n.t('Common:no')}
      </td>
      <td className="align-middle">
        <Button color="primary" onClick={onEdit} disabled={!isEditable}>
          <FaEdit className="me-1" />
          {i18n.t('Common:edit')}
        </Button>
      </td>
    </tr>
  );
}
